import classNames from 'classnames';
import { object, shape } from 'prop-types';
import React from 'react';
import { Input } from '@eika/input';
import { SkjemaSporsmal } from '../../ahv-schema';
import {
    BM_FATCA_TIN,
    BM_FATCA_V2_TIN,
    BM_FINANSIELL_INSTUTISJON_GIN,
    PM_FATCA_TIN,
    PM_FATCA_V2_TIN,
} from '../../constants/definisjoner';
import connect from '../helper/connect';
import { isTextEmpty, validerMonster } from '../helper/validation-helper';
import ErrorMessage from '../errormessage';

const isInvalid = (question, context, hasInvalidValue) => {
    const currentValue = context.getValue(question.definisjon);
    return hasInvalidValue || isTextEmpty(currentValue) || !validerMonster(currentValue, question.valideringsMonster);
};

function Giin(props) {
    const { question, hasInvalidValue, onChange, context, disabled } = props;
    const { definisjon, sporsmalstekst } = question;

    return (
        <Input
            onChange={onChange}
            name={definisjon}
            className={classNames('form-control', { invalid: hasInvalidValue })}
            placeholder="XXXXXX.XXXXX.BB.TTT"
            value={context.getValue(definisjon)}
            id={definisjon}
            onBlur={() => context.updateValidation(definisjon, true, isInvalid(question, context, hasInvalidValue))}
            aria-label={sporsmalstekst}
            disabled={disabled}
            type="text"
        />
    );
}

function Tin(props) {
    const { question, onChange, hasInvalidValue, context, disabled } = props;
    const { definisjon } = question;
    return (
        <div>
            <Input
                onChange={onChange}
                name={definisjon}
                className={classNames('form-control', { invalid: hasInvalidValue })}
                placeholder="XXX-XX-XXXX"
                value={context.getValue(definisjon)}
                onBlur={() => context.updateValidation(definisjon, true, isInvalid(question, context, hasInvalidValue))}
                id={definisjon}
                disabled={disabled}
                type="text"
            />
        </div>
    );
}

function InputGroup(props) {
    const { question, onChange, context, disabled, hasError } = props;
    const { definisjon, detaljtekst, reminder = false } = question;
    return (
        <>
            <Input
                type="text"
                name={definisjon}
                onChange={onChange}
                className="form-control"
                value={context.getValue(definisjon)}
                id={definisjon}
                disabled={disabled}
                onBlur={() => context.updateValidation(definisjon, true, hasError())}
                label={detaljtekst}
            />
            {reminder && (
                <div className="skjema-input-reminder">
                    <div className="ikon-utropstegn-36 exclamationmark" />
                    {reminder}
                </div>
            )}
        </>
    );
}

function isValidTINSibling(siblingValue) {
    return siblingValue.length > 0;
}

function isValidGINSibling(siblingValue) {
    return siblingValue.length > 0;
}

function TextQuestionType(props) {
    const { question, context, isSubQuestion } = props;
    const { definisjon, instruks, sporsmalstekst, valideringsMonster, validateIfNotSet, config } = question;

    const hasError = () => {
        if (validateIfNotSet && validateIfNotSet.length > 0) {
            const siblingValue = context.getValue(validateIfNotSet[0].definisjon);
            if (isValidTINSibling(siblingValue, definisjon) || isValidGINSibling(siblingValue, definisjon)) {
                return false;
            }
        }

        const currentValue = context.getValue(definisjon);
        const touched = context.touched(definisjon);
        const hasSubmitted = context.getHasSubmitted();
        return (
            (touched || hasSubmitted) &&
            (isTextEmpty(currentValue) || !validerMonster(currentValue, valideringsMonster))
        );
    };

    const hasInvalidValue = hasError();
    const onChange = (e) => {
        context.onChange(definisjon, {
            value:
                config && config.textNoWhitespace ? e.target.value.replace(new RegExp(/\s/, 'g'), '') : e.target.value,
            error: hasError(),
        });
    };
    /* eslint-disable react/jsx-props-no-spreading */
    const renderInput = () => {
        if ([PM_FATCA_TIN, BM_FATCA_TIN, PM_FATCA_V2_TIN, BM_FATCA_V2_TIN].includes(definisjon)) {
            return <Tin {...props} onChange={onChange} hasInvalidValue={hasInvalidValue} />;
        }
        if ([BM_FINANSIELL_INSTUTISJON_GIN].includes(definisjon)) {
            return <Giin {...props} onChange={onChange} hasInvalidValue={hasInvalidValue} />;
        }
        return <InputGroup {...props} onChange={onChange} hasInvalidValue={hasInvalidValue} hasError={hasError} />;
    };

    return (
        <div className={classNames({ 'has-error error': hasInvalidValue })}>
            {isSubQuestion && <h2 className="skjema-input-question">{sporsmalstekst}</h2>}
            {renderInput()}
            {hasInvalidValue && <ErrorMessage text={instruks} />}
        </div>
    );
}

TextQuestionType.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
    context: object,
};

export default connect(React.memo(TextQuestionType));
